'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';

interface SelectAllBannerProps {
  isAllPagesSelected: boolean;
  isCurrentPageFullySelected: boolean;
  currentPageCount: number;
  totalCount: number;
  pageSize: number;
  onSelectAllPages: () => void;
  onClearSelection: () => void;
}

export function SelectAllBanner({
  isAllPagesSelected,
  isCurrentPageFullySelected,
  currentPageCount,
  totalCount,
  pageSize,
  onSelectAllPages,
  onClearSelection
}: SelectAllBannerProps) {
  const t = useTranslations('common');

  // Only show when current page is fully selected AND there are more items across pages
  if (!isCurrentPageFullySelected || totalCount <= pageSize) {
    return null;
  }

  return (
    <div className='bg-muted/50 border-border flex items-center justify-center gap-1.5 rounded-lg border px-4 py-2 text-sm'>
      {isAllPagesSelected ? (
        <>
          <span>{t('allItemsSelected', { count: totalCount })}</span>
          <Button
            variant='link'
            size='sm'
            className='h-auto p-0 text-sm font-semibold'
            onClick={onClearSelection}
          >
            {t('clearSelection')}
          </Button>
        </>
      ) : (
        <>
          <span>{t('allOnPageSelected', { count: currentPageCount })}</span>
          <Button
            variant='link'
            size='sm'
            className='h-auto p-0 text-sm font-semibold'
            onClick={onSelectAllPages}
          >
            {t('selectAllItems', { count: totalCount })}
          </Button>
        </>
      )}
    </div>
  );
}
